export enum registerInspector {
 notQualified = 1,
 underQualification = 2,
 waitingDevices = 3 ,
 qualified = 4,
 readyForTraining = 5,
 underTraining = 6,
 readyForQualification = 7
}
